import { render, staticRenderFns } from "./EducationPlayer.vue?vue&type=template&id=294a732a&scoped=true&"
import script from "./EducationPlayer.vue?vue&type=script&lang=ts&"
export * from "./EducationPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./EducationPlayer.vue?vue&type=style&index=0&id=294a732a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294a732a",
  null
  
)

export default component.exports